module.exports = __webpack_public_path__ + "static/media/firebase.5b979dad.svg";